module.exports = __webpack_public_path__ + "static/img/11.4dc8c18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index-mb/story/11.png
// module id = 3kjD
// module chunks = 1